<div *ngIf="errorText">{{ errorText }}</div>
